<template>
    <div class="modal-dialog onload-modal  modal-dialog-centered" style="display: block;">
        <div class="modal-content">
            <div class="container">
                <div class="recent-bank-sec bg-wrong">
                    <div class="recent-bank">
                        <div class="bank-icon">
                            <img  rel="preload"   src="@/assets/images/wrong-icon.webp" alt="">
                        </div>
                        <div class="bank-con">
                            <h6>{{ this.$t('wrong', 'Wrong') }}!</h6>
                            <span v-html="message"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ErrorModal",
    props: ['message']
}
</script>